module.exports = __webpack_public_path__ + "static/case-slide-5-968810295e5524c75ab0ca840e6058f3.jpg";